export default "__VITE_ASSET__BwDOCwVi__"